import { isObject, makePathnameWithLanguage, useLanguage } from '@/utils'
import { evolve, ifElse } from 'ramda'
import { Navigate, To } from 'react-router-dom'

export type RedirectTo = string | { pathname: string }

const makeRedirectPath = (language: string) =>
  // @ts-expect-error solve when we remove ramda
  ifElse(
    isObject,
    evolve({ pathname: makePathnameWithLanguage(language) }),
    makePathnameWithLanguage(language),
  )

interface RedirectProps {
  to: RedirectTo
  state?: Record<string, unknown>
}

export const Redirect = ({ to, state }: RedirectProps) => {
  const language = useLanguage()

  const makeTo = makeRedirectPath(language)

  return <Navigate state={state} to={makeTo(to) as To} />
}
